import { Link } from "react-router-dom";
import localizedLink from "./localizedLink";

const POLICY_PATHS = {
    warranty: "/policies/warranty",
    delivery: "/policies/delivery",
    returns: "/policies/returns",
    privacy: "/policies/privacy",
    terms: "/policies/terms-and-conditions",
};

// Turns tags like "<returns>Returns</returns>" in a translation into links to
// that policy page; the rest of the text stays as it is.
export default function withPolicyLinks(text, language) {
    return text.split(/(<\w+>.*?<\/\w+>)/).map((part, index) => {
        const [, name, label] = part.match(/^<(\w+)>(.*)<\/\1>$/) ?? [];
        if (!POLICY_PATHS[name]) return part;
        return (
            <Link key={index} to={localizedLink(POLICY_PATHS[name], language)} className="underline">
                {label}
            </Link>
        );
    });
}
